import { Component, Input, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ChildCommentCategory, WBCommentCategory, WBCreateCommentCategory } from 'src/app/misc/workspace/models/workbook-comment.models';
import { WorkbookCommentService } from 'src/app/misc/workspace/services/workbook-comment.services';

@Component({
  selector: 'app-workspace-comment-category',
  templateUrl: './workspace-comment-category.component.html',
  styleUrl: './workspace-comment-category.component.scss'
})
export class WorkspaceCommentCategoryComponent {

    /** Subscription and Cleanup */
    protected ngUnsubscribe$: Subject<void> = new Subject<void>(); 
  @Input() reloadCategory: boolean = false;

  commentCategories: WBCommentCategory[] = []
  
  displayCreateUpdateCommentCategory: boolean = false;
  isEditMode: boolean = false;
  selectedCategory: any = null;
  showParentCategory: boolean = false;

  constructor(
    private readonly app: AppMainComponent,
    public readonly workbookCommentService: WorkbookCommentService,
    private readonly appMainService: AppMainService,
    private readonly confirmationService: ConfirmationService,
    private readonly messageService: MessageService,
    private fb: FormBuilder
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reloadCategory']) {
       this.getWBCommentCategory();
    }

  }
  editCategory(category: WBCommentCategory) {
    this.selectedCategory= category;
    this.isEditMode = true;
    this.displayCreateUpdateCommentCategory = true;
    this.showParentCategory = false;
  }

  hideCreateUpdateCategory(event: any) {
    this.displayCreateUpdateCommentCategory = false;
    this.showParentCategory = false;
    this.selectedCategory = null;
    this.isEditMode = false;
  }

  deleteCategory(categoryId: string) {
    this.deleteCommentCategory(categoryId);

  }

  editChildCategory(parent, child) {
    const selectedChildCategory = {
      id: child.id,
      name: child.name,
      color: child.color,
      parentId: parent.id
    }
    this.selectedCategory = selectedChildCategory;
    this.showParentCategory = true;
    this.isEditMode = true;
    this.displayCreateUpdateCommentCategory = true;
  }

  deleteChildCategory(categoryId: string, childId: string) {
    this.deleteCommentCategory(childId);
  }

  getWBCommentCategory() {
    this.appMainService.isShowSpinner('getWBCommentCategory');
    this.workbookCommentService.getCommentCategory().pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: any) => {
        this.appMainService.isHideSpinner('getWBCommentCategory');
        this.commentCategories = response;
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getWBCommentCategory');
        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to get comment category!' });
        this.commentCategories = [];
      }
    })
  }

  deleteCommentCategory(commentCategoryId: string) {        
    this.confirmationService.confirm({
      message: 'Do you want to delete this Comment Category?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.appMainService.isShowSpinner('deleteCommentCategory');
        this.workbookCommentService.deleteCommentCategory(commentCategoryId).pipe(
          takeUntil(this.ngUnsubscribe$)
        ).subscribe({
          next: (response: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Comment Category deleted successfully!' });
            this.appMainService.isHideSpinner('deleteCommentCategory');
            this.getWBCommentCategory();
            // this.workbookComments = response;
          },
          error: (error) => {
            this.appMainService.isHideSpinner('deleteCommentCategory');
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message || 'Failed to delete comment category!' });  
          }
        });
      },
      reject: () => { },
    });
  }
  
  refreshCategory(event: any) {
    this.getWBCommentCategory();
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }  

}
